<form class="app-grid" #form="ngForm" *ngIf="role">
    <mat-form-field>
        <mat-label>Name</mat-label>
        <input
            matInput
            type="text"
            name="name"
            required
            #name="ngModel"
            [(ngModel)]="role.name"
            placeholder="e.g. Hiring Manager"
        />
        <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
    </mat-form-field>

    <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea matInput required #description="ngModel" name="description" [(ngModel)]="role.description"></textarea>
        <mat-error *ngIf="description.invalid">{{ description.errors | formErrors }}</mat-error>
    </mat-form-field>
</form>
